<app-content>
  <app-breadcrumbs>
    <li>
      Budżet obywatelski
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Budżet obywatelski
    </h2>
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <div class='row'>
        <div class='col-12'>
          <ul class='item-list'>
            <li *ngFor='let item of (budgets() || []); let index = index'>
              <div>
                <a [routerLink]="item?.id">{{ item.name }}</a> @if (item.stage === 'project_submission') {
                <span class="ms-2 color--green">
                  <i class="fa fa-info-circle me-1"></i><small>Zgłaszanie projektów</small>
                </span>
              }
              </div>
              <div>
                <small>{{ item.description }}</small>
              </div>
            </li>
          </ul>
          <app-alert content='Brak zdefiniowanych Budżetów Obywatelskich'
                     *ngIf='!budgets()?.length'
                     [closable]='false'>
          </app-alert>
        </div>
      </div>
    }
  </section>
</app-content>
